<template lang="pug">
  .dropdown-countries
    .dropdown(:class="{ 'is-active': activeDropdown, 'selected': isSelected }")
      .dropdown-trigger
        button.button(@click="toggleDropdown")
          span {{ selectedItem[itemName] || labelText }}
      .dropdown-menu(role="menu")
        .dropdown-content
          a.dropdown-item(
            v-for="country in countries"
            @click="selectItem(country)") {{ country[itemName] }}
</template>

<script>
import { mapGetters } from 'vuex'
import { gettext } from '@/services/TranslateHandler'

export default {
  name: 'DropdownCountries',
  props: {
    countries: {
      default: () => {
        return []
      }
    },
    labelText: {
      default: gettext('All countries')
    },
    itemName: {
      default: 'name'
    },
    itemValue: {
      default: ''
    }
  },
  data () {
    return {
      activeDropdown: false,
      isSelected: false,
      selectedItem: ''
    }
  },
  methods: {
    toggleDropdown () {
      this.activeDropdown = !this.activeDropdown
    },
    selectItem (item) {
      this.activeDropdown = false
      this.selectedItem = item
      this.isSelected = true
      this.$emit('input', this.itemValue ? this.selectedItem[this.itemValue] : this.selectedItem)
      this.$emit('selected', this.itemValue ? this.selectedItem[this.itemValue] : this.selectedItem)
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  created () {
    window.addEventListener('click', (e) => {
      if (!e.target.closest('.dropdown')) {
        this.activeDropdown = false
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/countries/components/dropdown-countries/index.vue